<template>
  <div v-if="badge" class="gl-button-wrapper">
    <md-button v-on="$listeners" v-bind="$attrs" :class="classes">
      <gl-icon v-if="iconPre" :icon="iconPre" />
      <span class="text">
        <slot></slot>
      </span>
      <gl-icon v-if="iconPost" :icon="iconPost" />
    </md-button>
    <span
      :gl-tooltip="tooltipText"
      :class="['badge-dot', `badge-dot--${badgeVariant}`]"
    ></span>
  </div>

  <md-button v-else v-on="$listeners" v-bind="$attrs" :class="classes">
    <gl-icon v-if="iconPre" :icon="iconPre" />
    <span class="text">
      <slot></slot>
    </span>
    <gl-icon v-if="iconPost" :icon="iconPost" />
  </md-button>
</template>

<script>
/**
 * アプリケーション共通で使用するボタンコンポーネント
 *
 * Material Designのボタンです。
 */
export default {
  props: {
    iconButton: {
      type: Boolean,
      default: false,
    },
    raised: {
      type: Boolean,
      default: false,
    },
    primary: {
      type: Boolean,
      default: false,
    },
    accent: {
      type: Boolean,
      default: false,
    },
    plain: {
      type: Boolean,
      default: false,
    },
    fab: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    /**
     * ボタンテキストの前に表示するアイコン
     */
    iconPre: {
      type: String,
    },
    /**
     * ボタンテキストの後ろに表示するアイコン
     */
    iconPost: {
      type: String,
    },
    /**
     * アイコンボタンのバッジの有無
     */
    badge: {
      type: Boolean,
      default: false,
    },
    /**
     * ツールチップテキスト
     */
    tooltipText: {
      type: String,
      default: '',
    },
    /**
     * バッジの色バリアント
     */
    badgeVariant: {
      type: String,
      default: 'primary',
      validator: value => ['primary', 'warn'].includes(value),
    },
  },
  computed: {
    classes() {
      return {
        'md-icon-button': this.iconButton,
        'md-raised': this.raised,
        'md-primary': this.primary,
        'md-accent': this.accent,
        'md-fab': this.fab,
        'md-plain': this.plain,
        'md-dense': this.dense,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
$icon-margin: 5px;

.text {
  &:not(:first-child) {
    margin-left: $icon-margin;
  }
  &:not(:last-child) {
    margin-right: $icon-margin;
  }
}

.gl-icon {
  height: 16px;
}
.gl-button-wrapper {
  position: relative;
  display: inline-block;
}
.badge-dot {
  position: absolute;
  z-index: 5;
  top: 8px;
  right: 8px;
  width: 12px;
  height: 12px;
  color: white;
  border-radius: 50%;
  box-shadow: 0 0 0 2px white;

  &--primary {
    background: var(--color-primary);
  }
  &--warn {
    background: var(--color-warn);
  }
}
</style>
